import React, { useEffect } from 'react';
import { Form, Spin } from 'antd';
import useGetPPAServiceSpecialtyList from 'hooks/useGetPPAServiceSpecialtyList';
import SpecialtySelector from 'components/SpecialtySelector';
import { IPPAServiceSpecialty } from 'types/ppaOnboarding';
import s from './s.module.less';

interface Props {
    // previously-selected specialty name, used to restore the selection on Back
    value?: string;
    onSpecialtyChange?: (specialtyName: string) => void;
}

const SetupServicesStep: React.FC<Props> = ({ value, onSpecialtyChange }) => {
    const [form] = Form.useForm();
    const [specialties, loading] = useGetPPAServiceSpecialtyList();

    useEffect(() => {
        if (value && specialties.length) {
            const matched = specialties.find((item) => item.specialtyName === value);
            if (matched) {
                form.setFieldsValue({ specialty: matched });
            }
        }
    }, [value, specialties, form]);

    const handleChange = (val: IPPAServiceSpecialty) => {
        onSpecialtyChange?.(val.specialtyName);
    };

    if (loading) {
        return <Spin spinning />;
    }

    return (
        <div className={s.wrap}>
            <h1 className={s.heading}>Select one specialty to set up first</h1>
            <p className={s.description}>
                Selecting a specialty helps us list your services where the right patients can find you quickly. You can
                add or edit specialties anytime.
            </p>
            <Form form={form} layout="vertical">
                <Form.Item name="specialty" rules={[{ required: true, message: 'Please select a specialty!' }]}>
                    <SpecialtySelector specialties={specialties} onChange={handleChange} />
                </Form.Item>
            </Form>
        </div>
    );
};

export default SetupServicesStep;
